import { Component, Input, signal } from '@angular/core';
import { Validators } from '@angular/forms';
import { CustomFieldDetailDto } from '@artemis-software/wr-api';
import { createForm } from '@sonofabit/ng-core';

@Component({
  standalone: false,
  selector: 'wr-custom-field-form',
  templateUrl: './custom-field-form.component.html',
  styleUrls: ['./custom-field-form.component.scss'],
})
export class CustomFieldFormComponent {

  @Input() folderPath = '';

  @Input()
  set customField(value: CustomFieldDetailDto | null) {
    this.form = this.createFormFromDetail(value);
  }

  canEdit = signal(false);
  form = this.createFormFromDetail(null);

  createFormFromDetail(detail: CustomFieldDetailDto | null) {
    this.canEdit.set(detail ? !!detail.permissions.canEdit : true);
    return createForm(({ field }) => {
      return {
        id: field({ value: detail?.id }),
        name: field({ value: detail?.name, validators: [Validators.required] }),
        description: field({ value: detail?.description }),
        composition: field({ value: detail?.composition, validators: [Validators.required] }),
        category: field({ value: detail?.category ?? this.folderPath }),
      };
    });
  }
}
